import type * as React from 'react';
import { Skeleton } from '@avanta/shared/components/ui/Skeleton';
import { TableCell, TableRow } from '@avanta/shared/components/ui/Table';
import { cn } from '@avanta/shared/utils/cn';

interface TableSkeletonProps {
  columns: number;
  rows?: number;
}

export const TableSkeleton = ({ columns, rows = 4 }: TableSkeletonProps): React.ReactElement => (
  <>
    {Array.from({ length: rows }).map((_, rowIndex) => (
      <TableRow key={`table-skeleton-row-${rowIndex}`} aria-hidden="true">
        {Array.from({ length: columns }).map((_, columnIndex) => {
          const isActionsColumn = columnIndex === columns - 1;

          return (
            <TableCell key={`table-skeleton-cell-${rowIndex}-${columnIndex}`} className="last:w-px">
              <Skeleton
                className={cn(
                  'h-4',
                  isActionsColumn ? 'w-8' : columnIndex % 2 === 0 ? 'w-3/4' : 'w-1/2'
                )}
              />
            </TableCell>
          );
        })}
      </TableRow>
    ))}
  </>
);
